export default __webpack_public_path__ + "static/media/projects.03376be9.svg";